'use strict';

var FaresManagerClassUsageAggregationFactory = function FaresManagerClassUsageAggregationFactory(dataAggregationFactory, momentService) {
  function createKey(marketOrigin, marketDestination, clazz, monthId) {
    return '' + marketOrigin + ' ' + marketDestination + ' ' + clazz + ' ' + monthId;
  }
  function getMarket(data) {
    return data.marketOrigin + '-' + data.marketDestination;
  }
  function reduceData(dataToReduce) {
    var trafficSum = 0;
    var dateRange = momentService.getFaresDateRange();
    for (var index = 0, dataToReduceLength = dataToReduce.length; index < dataToReduceLength; index++) {
      if (momentService.isEventTimeWithinRange(dataToReduce[index].eventTimeStamp, dateRange)) {
        trafficSum += dataToReduce[index].traffic;
      }
    }
    return {
      market: getMarket(dataToReduce[0]),
      marketOrigin: dataToReduce[0].marketOrigin,
      marketDestination: dataToReduce[0].marketDestination,
      className: dataToReduce[0].className,
      month: dataToReduce[0].month,
      traffic: trafficSum
    };
  }
  function FaresManagerClassUsageAggregation() {
    dataAggregationFactory.call(this, 'fares-chart-mode', 'fares-class-usage-chart');
  }
  FaresManagerClassUsageAggregation.prototype = Object.create(dataAggregationFactory.prototype);
  FaresManagerClassUsageAggregation.constructor = FaresManagerClassUsageAggregation;
  FaresManagerClassUsageAggregation.prototype.aggregate = function (data) {
    var group = {};
    var result = [];
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      var element = data[index];
      var key = createKey(element.marketOrigin, element.marketDestination, element.className, element.month);
      group[key] = group[key] || [];
      group[key].push(element);
    }
    index = 0;
    for (var groupKeys = Object.keys(group), groupLength = groupKeys.length; index < groupLength; index++) {
      var reducedElement = reduceData(group[groupKeys[index]]);
      result.push(reducedElement);
    }
    return result;
  };
  return FaresManagerClassUsageAggregation;
};
FaresManagerClassUsageAggregationFactory.$inject = ['DataAggregationFactory', 'MomentService'];
module.exports = FaresManagerClassUsageAggregationFactory;